export default function PreviewAbout({ config }) {
  const about = config?.website?.about || {};

  return (
    <section style={{ padding: "0 24px 26px" }}>
      <div
        style={{
          borderRadius: "var(--ns-radius-lg)",
          background: "var(--ns-card)",
          border: "1px solid var(--ns-card-border)",
          boxShadow: "var(--ns-shadow)",
          padding: 18
        }}
      >
        <div
          style={{
            color: "var(--ns-ink)",
            fontWeight: 950,
            fontSize: 20,
            marginBottom: 10
          }}
          dangerouslySetInnerHTML={{
            __html: about.nameHtml || "<h2>About the Restaurant</h2>"
          }}
        />

        <div
          style={{
            color: "rgba(11,18,32,0.82)",
            lineHeight: 1.75,
            fontSize: 14
          }}
          dangerouslySetInnerHTML={{
            __html:
              about.storyHtml ||
              "<p>Share your story: cuisine, inspiration, chef highlights, ambience and what makes you special.</p>"
          }}
        />
      </div>
    </section>
  );
}
